import React from 'react';
import { View, ViewStyle, TextStyle, StyleProp } from 'react-native';
import { Text } from '@/components/common/text';

type DesktopSectionHeaderProps = {
  title: string;
  subtitle?: string;
  containerStyle?: StyleProp<ViewStyle>;
  titleStyle?: StyleProp<TextStyle>;
  subHeaderContainerStyle?: StyleProp<ViewStyle>;
  subHeaderTextStyle?: StyleProp<TextStyle>;
};

export const DesktopSectionHeader: React.FC<DesktopSectionHeaderProps> = ({
  title,
  subtitle,
  containerStyle,
  titleStyle,
  subHeaderContainerStyle,
  subHeaderTextStyle,
}) => {
  return (
    <>
      <View style={containerStyle}>
        <Text style={titleStyle}>{title}</Text>
      </View>
      {subtitle ? (
        <View style={subHeaderContainerStyle}>
          <Text style={subHeaderTextStyle}>{subtitle}</Text>
        </View>
      ) : null}
    </>
  );
};

export default DesktopSectionHeader;


